<template>
  <default-layout>
    <event-navbar :title="info_title" />
    <v-runtime-template :template="info_content"></v-runtime-template>
    <br>
  </default-layout>
</template>

<script>
// @ is an alias to /src
import VRuntimeTemplate from "v-runtime-template";
import DefaultLayout from '@/components/DefaultLayout.vue'
import EventNavbar from '@/components/EventNavbar.vue'

export default {
  name: 'EventInfoView',
  components: {
    VRuntimeTemplate, DefaultLayout, EventNavbar
  },
  data() {
    return {
      info_content: '',
      info_title: '',
    }
  },

  computed: {
    storageKey() {
      return `zpcard-info-content-${this.$route.params.shortName}-${this.$route.params.infopage}`
    }
  },

  created() {
      let me = this
      if (navigator.onLine) {
        this.$api.get(`zpcard/${this.$route.params.shortName}/${this.$route.params.infopage}/`).then((response) => {
          me.info_content = response.data.html
          me.info_title = response.data.title
          localStorage.setItem(this.storageKey, me.info_content)
        })
      } else {
          me.info_content = localStorage.getItem(this.storageKey)
      }
  },

}
</script>
